import {
  Group,
  Menu,
  MenuDropdown,
  MenuItem,
  MenuTarget,
  Text,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useTransition } from "react";
import { IconWorld } from "@tabler/icons-react";

const languages = [
  { label: "English", value: "en" },
  { label: "Deutsch", value: "de" },
];

function LangSelector() {
  const { i18n } = useTranslation();
  const [isPending, startTransition] = useTransition();

  const currentLabel = languages.find((l) => l.value === i18n.language)?.label ?? "EN";

  function selectLanguage(value) {
    startTransition(() => {
      i18n.changeLanguage(value);
      localStorage.setItem("i18nLang", value);
    });
  }

  return (
    <Menu disabled={isPending} trigger="click-hover" openDelay={10} closeDelay={100}>
      <MenuTarget>
        <Group gap={4} style={{ cursor: "pointer" }}>
          <IconWorld stroke={1.5} size={20} />
          {/* Globe-only on phones: the language word crowds the header bar; the icon is a clear
              enough affordance. click-hover so the menu opens on tap on touch devices. */}
          <Text size="sm" visibleFrom="sm">{currentLabel}</Text>
        </Group>
      </MenuTarget>
      <MenuDropdown>
        {languages.map((lang) => (
          <MenuItem
            key={lang.value}
            onClick={() => selectLanguage(lang.value)}
            fw={i18n.language === lang.value ? 700 : 400}
          >
            {lang.label}
          </MenuItem>
        ))}
      </MenuDropdown>
    </Menu>
  );
}

export default LangSelector;